module.exports = __webpack_public_path__ + "static/media/waldfestq.0c6f2d2a.png";